// studioStageVisibility — whether the hardcoded studio floor + reference grid
// render this frame.
//
// The studio stage (a 400×400 plane at y=0 plus a 10m gridHelper just above it)
// is the authoring backdrop for a scene with no environment: without it the
// avatar floats in a void with no ground reference. It has always stood down
// for an active environment, which brings its own floor, and for the BACKDROP
// ground plane, which is a floor at the same height and would z-fight.
//
// It now also stands down for the backdrop SKY, and that case is the reason this
// module exists. The studio floor's color is hardcoded (0x1a1a2e, a dark navy
// that reads as black in a scene with no IBL), so a user who enabled the sky and
// picked a background color still saw a black floor under it. The only way to
// get rid of it was to ALSO enable the ground plane and set its color to match —
// i.e. set the background twice, which is exactly how it was reported
// (Isaac, 2026-09-01: "BG color currently has to be set twice for the bg and the
// ground plane, because turning off ground plane still shows a black ground").
//
// The rule is therefore: an EXPLICITLY AUTHORED backdrop owns the frame. It is
// deliberately gated on the sky flag rather than dropping the studio stage
// outright — `skyEnabled` is opt-in and off by default, so someone who has never
// opened the BACKDROP section keeps the floor they have always had, while
// someone who has just said "the background is this color" gets that color and
// nothing else.
//
// Pure, and its own module, because `Scene.jsx` cannot be imported under
// `node --test` (R3F + THREE + extensionless relative imports). Same precedent
// as `graphGroup.js`.

/**
 * @param {object} input
 * @param {boolean} input.hasEnv        an environment splat is active
 * @param {boolean} input.skyEnabled    backdrop.skyEnabled
 * @param {boolean} input.groundEnabled backdrop.groundEnabled
 * @returns {boolean} render the studio floor + reference grid
 */
export function showStudioStage({ hasEnv, skyEnabled, groundEnabled } = {}) {
  if (hasEnv) return false
  if (groundEnabled) return false
  if (skyEnabled) return false
  return true
}
